export default {
    common: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        save: 'Save',
        success: 'Success',
        fail: 'Failed',
        hint: 'Hint',
        send: 'Send'
    },
    components: {
        setting: {
            UserConfig: {
                privacySettings: 'Privacy Settings',
                friendVerify: 'Friend Request Verification',
                notificationSettings: 'Notification Settings',
                messageTone: 'New Message Audio Alert'
            },
            BindEmail: {
                successTitle: 'Email Bound Successfully',
                successDesc: 'Your email {email} has been bound successfully',
                suggestTitle: 'Suggest Binding Email',
                suggestDesc: 'After binding email, you can quickly reset password via email to improve account security',
                bindTitle: 'Bind Email',
                emailLabel: 'Email',
                emailPlaceholder: 'Please enter email address',
                codeLabel: 'Verification Code',
                codePlaceholder: 'Please enter verification code',
                retryInSeconds: 'Retry in {time}s',
                getCode: 'Get Code',
                bindBtn: 'Bind',
                emailRequired: 'Please enter email',
                emailFormatError: 'Email format error',
                codeRequired: 'Please enter verification code',
                bindConfirm: 'Cannot be changed after binding, confirm to bind?',
                bindSuccess: 'Email bound successfully',
                codeSent: 'Verification code sent to your email, please check',
                sendFail: 'Failed to send verification code'
            },
            BindPhone: {
                successTitle: 'Phone Bound Successfully',
                successDesc: 'Your phone number {phone} has been bound successfully',
                suggestTitle: 'Suggest Binding Phone',
                suggestDesc: 'After binding phone number, you can quickly reset password via phone to improve account security',
                bindTitle: 'Bind Phone',
                phoneLabel: 'Phone Number',
                phonePlaceholder: 'Please enter phone number',
                codeLabel: 'Verification Code',
                codePlaceholder: 'Please enter verification code',
                retryInSeconds: 'Retry in {time}s',
                getCode: 'Get Code',
                bindBtn: 'Bind',
                phoneRequired: 'Please enter phone number',
                phoneFormatError: 'Phone number format error',
                codeRequired: 'Please enter verification code',
                bindConfirm: 'Cannot be changed after binding, confirm to bind?',
                bindSuccess: 'Phone number bound successfully',
                codeSent: 'Verification code sent to your phone, please check',
                sendFail: 'Failed to send verification code'
            },
            ModifyPassword: {
                title: 'Change Password',
                oldPassword: 'Old Password',
                newPassword: 'New Password',
                confirmPassword: 'Confirm Password',
                submit: 'Submit',
                passwordRequired: 'Please enter password',
                passwordMismatch: 'Passwords do not match',
                success: 'Password changed successfully'
            },
            PersonalInfo: {
                changeAvatar: 'Change Avatar',
                defaultNickName: 'Nickname not set',
                unknownUser: 'Unknown User',
                basicInfo: 'Basic Info',
                company: 'Company',
                nickName: 'Nickname',
                nickNamePlaceholder: 'Please enter nickname',
                gender: 'Gender',
                male: 'Male',
                female: 'Female',
                contactInfo: 'Contact Info',
                phone: 'Phone',
                noPhoneBound: 'Phone not bound',
                goToBind: 'Bind Now',
                email: 'Email',
                noEmailBound: 'Email not bound',
                signature: 'Signature',
                signaturePlaceholder: 'Share your mood and thoughts...',
                submit: 'Submit',
                nickNameRequired: 'Please enter nickname',
                success: 'Updated successfully'
            },
            RealnameAuth: {
                successTitle: 'Real-name Authentication Successful',
                successDesc: 'Your real-name authentication has been approved',
                realName: 'Real Name',
                idCardNumber: 'ID Card Number',
                authTime: 'Authentication Time',
                pendingTitle: 'Authentication Pending',
                pendingDesc: 'Your real-name authentication application is under review, please wait patiently',
                resubmit: 'Resubmit',
                failTitle: 'Authentication Failed',
                failReason: 'Failure Reason',
                failDesc: 'Your real-name authentication application was rejected, please resubmit',
                tipTitle: 'Authentication Instructions',
                tipDesc: 'Real-name authentication improves account security. Please ensure uploaded ID photos are clear and information is valid',
                resubmitTip: 'Resubmitting will overwrite previous authentication information',
                authTitle: 'Real-name Authentication',
                realNamePlaceholder: 'Please enter real name',
                idCardPlaceholder: 'Please enter ID card number',
                idCardFront: 'ID Card Front',
                uploadFront: 'Upload Front',
                frontTip: 'Please upload clear photo of ID card front',
                idCardBack: 'ID Card Back',
                uploadBack: 'Upload Back',
                backTip: 'Please upload clear photo of ID card back',
                submitAuth: 'Submit Authentication',
                realNameRequired: 'Please enter real name',
                realNameLength: 'Name length should be between 2-20 characters',
                idCardRequired: 'Please enter ID card number',
                idCardFormatError: 'ID card number format error',
                frontRequired: 'Please upload ID card front photo',
                backRequired: 'Please upload ID card back photo',
                confirmSubmit: 'Information cannot be modified after approval, confirm to submit?',
                 submitSuccess: 'Application submitted, please wait for review',
                 preview: 'Preview'
            }
        },
        Login: {
            loadingText: 'Logging in...',
            title: 'Login IM',
            passwordPlaceholder: 'Password',
            autoLogin: 'Auto Login',
            forgotPassword: 'Forgot Password?',
            loginBtn: 'Login',
            qrLogin: 'QR Code Login',
            registerLink: 'No account? Register now',
            usernameRequired: 'Please enter username',
            passwordRequired: 'Please enter password',
            loginSuccess: 'Login successful',
            username: 'Username',
            phone: 'Phone',
            email: 'Email'
        },
        Register: {
            modeUsername: 'Username Register',
            modePhone: 'Phone Register',
            modeEmail: 'Email Register',
            phonePlaceholder: 'Phone Number',
            codePlaceholder: 'SMS Code',
            emailPlaceholder: 'Email',
            emailCodePlaceholder: 'Email Code',
            usernamePlaceholder: 'Username',
            passwordPlaceholder: 'Password',
            confirmPasswordPlaceholder: 'Confirm Password',
            getCode: 'Get Code',
            retryInSeconds: 'Retry in {time}s',
            registerBtn: 'Register',
            toLogin: 'Already have an account? Login',
            otherMode: 'Other Registration Methods',
            phoneRequired: 'Please enter phone number',
            phoneFormatError: 'Phone number format error',
            emailRequired: 'Please enter email',
            emailFormatError: 'Email format error',
            usernameRequired: 'Please enter username',
            passwordRequired: 'Please enter password',
            passwordMismatch: 'Passwords do not match',
            registerSuccess: 'Registration successful, welcome to {appName}!',
            codeSentPhone: 'Verification code sent to your phone, please check',
            codeSentEmail: 'Verification code sent to your email, please check'
        },
        ResetPwd: {
            title: 'Password Reset Wizard',
            subTitle: 'Reset your password in just four steps',
            step1: 'Select Method',
            step2: 'Verify Identity',
            step3: 'Set Password',
            step4: 'Complete',
            selectMode: 'Please select password reset method',
            phoneMode: 'Reset via Phone',
            phoneModeDesc: 'Verify identity via SMS code',
            emailMode: 'Reset via Email',
            emailModeDesc: 'Verify identity via email code',
            nextStep: 'Next',
            verifyIdentity: 'Verify Your Identity',
            phoneLabel: 'Phone Number',
            phoneInputPlaceholder: 'Please enter your phone number',
            smsCodeLabel: 'SMS Code',
            smsCodeInputPlaceholder: 'Please enter SMS code',
            resend: 's resend',
            emailLabel: 'Email Address',
            emailInputPlaceholder: 'Please enter your email address',
            emailCodeLabel: 'Email Code',
            emailCodeInputPlaceholder: 'Please enter 6-digit email code',
            prevStep: 'Previous',
            verifyBtn: 'Verify',
            setNewPwd: 'Set New Password',
            newPwdLabel: 'New Password',
            newPwdPlaceholder: 'Please enter your new password',
            confirmPwdLabel: 'Confirm New Password',
            confirmPwdPlaceholder: 'Please enter your new password again',
            submitBtn: 'Submit',
            successTitle: 'Password Reset Successful!',
            successDesc: 'You have successfully reset your password. Please login with your new password.',
            autoRedirect: 'System will redirect to login page in {time} seconds',
            loginNow: 'Login Now',
            phoneError: 'Please enter correct phone number',
            emailError: 'Please enter correct email address',
            verifyFail: 'Verification failed, please re-enter code',
            cancelConfirm: 'Are you sure you want to cancel password reset?'
        },
        RtcGroupVideo: {
            title: 'Video Call',
            microphoneOn: 'Turn Off Mic',
            microphoneOff: 'Turn On Mic',
            speakerOn: 'Turn Off Speaker',
            speakerOff: 'Turn On Speaker',
            cameraOn: 'Turn Off Camera',
            cameraOff: 'Turn On Camera',
            shareScreen: 'Share Screen',
            cancelShare: 'Stop Sharing',
            inviteMember: 'Invite Member',
            quitCall: 'End Call',
            status: {
                chatting: 'On Call',
                calling: 'Calling'
            },
            success: {
                join: 'Successfully joined the call',
                leave: 'Left the call',
                invite: 'Invitation successful'
            },
            error: {
                cameraAccessFailed: 'Cannot access camera',
                rtcInitFailed: 'RTC init failed',
                deviceNotSupport: 'Your device does not support calls',
                joinFailed: 'Failed to join the call',
                leaveFailed: 'Failed to leave the call'
            }
        },
        AddFriend: {
            title: 'Add Friend',
            placeholder: 'ID/Nickname/Phone/Email, max 20',
            tag: {
                deleted: 'Deleted',
                banned: 'Banned'
            },
            label: {
                phone: 'Phone',
                email: 'Email',
                id: 'ID'
            },
            button: {
                sendMessage: 'Send Message',
                add: 'Add Friend'
            },
            status: {
                waiting: 'Waiting for verification'
            },
            noData: "No user found for '{searchText}'"
        },
        FriendApply: {
            title: 'Friend Request',
            tip: 'Tip: User requires verification, wait for approval',
            remark: 'I am {name}',
            success: {
                approved: "Added successfully, '{name}' is now your friend",
                pending: "You sent a friend request to '{name}'"
            }
        },
        FriendItem: {
            online: {
                computer: 'PC Online',
                mobile: 'Mobile Online'
            },
            menu: {
                chat: 'Send Message',
                card: 'Share Card',
                delete: 'Delete Friend'
            }
        },
        FriendRequest: {
            tab: {
                received: 'Received ({count})',
                sent: 'Sent ({count})'
            }
        },
        FriendRequestItem: {
            text: {
                sender: 'Request to add as friend',
                receiver: 'Request to add you as friend'
            },
            button: {
                reject: 'Reject',
                approve: 'Approve',
                recall: 'Recall'
            },
            success: {
                approve: '{name} is now your friend',
                reject: 'You rejected friend request from {name}',
                recall: 'You recalled friend request to {name}'
            }
        },
        ChatSelector: {
            search: {
                placeholder: 'Search'
            },
            tags: {
                group: 'Group'
            },
            tips: {
                checkedCount: '{count} contacts selected'
            },
            buttons: {
                remove: 'Remove'
            },
            tabs: {
                recent: 'Recent',
                friends: 'Friends',
                groups: 'Groups'
            }
        },

        Complaint: {
            title: 'Report',
            form: {
                target: 'Target',
                type: 'Reason',
                images: 'Evidence',
                content: 'Content'
            },
            placeholder: 'Please enter the details',
            required: {
                type: 'Please select a reason',
                content: 'Please enter the content'
            },
            success: 'We have received your report and will process it within 3 working days',
            image: {
                count: 'Uploaded {count} images',
                max: 'Max {max} images'
            }
        },
        ChatHistory: {
            title: 'Chat History',
            search: {
                placeholder: 'Search chat history'
            },
            tabs: {
                all: 'All',
                text: 'Text',
                image: 'Image',
                sticker: 'Sticker',
                file: 'File',
                voice: 'Voice',
                video: 'Video'
            },
            menu: {
                locate: 'Locate in Chat'
            },
            uploadedAt: 'uploaded at',
            noData: 'No data',
            noResult: "No result found for '{text}'"
        },
        ChatRecord: {
            title: 'Voice Recording',
            duration: 'Duration',
            states: {
                stop: 'Not Started',
                running: 'Recording...',
                pause: 'Recording Paused',
                complete: 'Recording Completed'
            },
            buttons: {
                start: 'Start Recording',
                pause: 'Pause',
                resume: 'Resume',
                complete: 'Complete',
                play: 'Play',
                stop: 'Stop Playing',
                restart: 'Restart',
                send: 'Send Now'
            }
        },
        RtcGroupAcceptor: {
            unknownUser: 'Unknown User',
            callStatus: 'Invites you to video call',
            participantsTitle: 'Other Participants',
            accept: 'Accept',
            reject: 'Reject'
        },
        RtcGroupJoin: {
            title: 'Video Call Invitation',
            host: 'Host: ',
            usersCount: '{count} people in call'
        },
        GroupMemberSelector: {
            title: 'Select Members',
            placeholder: 'Search members',
            tip: '{count} selected',
            error: {
                maxMembers: 'Max {max} members'
            }
        },
        GroupItem: {
            menu: {
                chat: 'Send Message',
                card: 'Share Card',
                dissolve: 'Dissolve Group',
                quit: 'Quit Group'
            }
        },
        GroupInfo: {
            tag: {
                banned: 'Banned'
            },
            label: {
                owner: 'Owner',
                members: 'Members',
                person: ''
            },
            button: {
                sendMessage: 'Send Message',
                join: 'Join Group'
            }
        },
        AddGroupMember: {
            title: 'Invite Members',
            placeholder: 'Search friends',
            tip: '{count} friends selected',
            success: 'Invited successfully'
        },
        GroupMemberBar: {
            tag: {
                me: 'Me',
                owner: 'Owner',
                manager: 'Admin',
                muted: 'Muted'
            }
        },
        GroupMemberDialog: {
            title: 'Group Members',
            tooltip: {
                invite: 'Invite Members',
                remove: 'Remove Members',
                mute: 'Mute Members',
                unmute: 'Unmute Members'
            },
            button: {
                invite: 'Invite',
                remove: 'Remove',
                mute: 'Mute',
                unmute: 'Unmute'
            }
        },
        GroupMemberItem: {
            menu: {
                sendMessage: 'Send Message',
                userInfo: 'View Profile',
                addFriend: 'Add Friend',
                mute: 'Mute',
                unmute: 'Unmute',
                kick: 'Remove',
                addManager: 'Set as Admin',
                removeManager: 'Remove Admin'
            },
            success: {
                mute: 'Muted {name}',
                unmute: 'Unmuted {name}',
                kick: 'Removed {name} from group',
                addManager: 'Set {name} as admin',
                removeManager: "Removed {name}'s admin status"
            },
            confirm: {
                title: 'Confirm Operation',
                kick: 'Are you sure you want to remove {name} from the group?'
            }
        },
        UserProfileCard: {
            title: 'User Profile',
            status: {
                online: 'Online'
            },
            detail: {
                company: 'Company',
                gender: 'Gender',
                phone: 'Phone',
                email: 'Email',
                signature: 'Signature'
            },
            gender: {
                male: 'Male',
                female: 'Female',
                unknown: 'Unknown'
            },
            signature: {
                empty: {
                    title: 'No signature set',
                    desc: 'Set a signature to show your unique self'
                }
            }
        },
        Chat: {
            searchPlaceholder: 'Search',
            loadingText: 'Receiving messages...',
            deleteConfirm: 'All records will be cleared after deletion. Are you sure you want to delete the chat with "{name}"?',
            deleteChat: 'Delete Chat',
            notInGroup: 'You are no longer in the group chat, cannot view group information'
        },
        Friend: {
            searchPlaceholder: 'Search',
            addFriend: 'Add Friend',
            newFriend: 'New Friends',
            sendMessage: 'Send Message',
            addAsFriend: 'Add as Friend',
            deleteFriend: 'Delete Friend',
            deleteFriendConfirm: 'Confirm to delete "{name}" and clear chat records?',
            deleteFriendConfirmTitle: 'Confirm Unfriend?',
            deleteFriendSuccess: 'Friend deleted successfully',
            sendSuccess: 'Sent successfully',
            editRemark: 'Edit Remark',
            inputRemark: 'Please enter friend remark',
            remarkLengthError: 'Friend remark length cannot exceed 32 characters',
            shareCard: 'Share Card',
            complaint: 'Complaint',
            online: 'Online',
            userInfo: {
                username: 'Username(ID)',
                nickName: 'Nickname',
                company: 'Company',
                remark: 'Remark',
                gender: 'Gender',
                signature: 'Signature',
                noRemark: 'No remark set',
                noSignature: 'This user hasn\'t set a signature yet',
                male: 'Male',
                female: 'Female'
            }
        },
        Group: {
            searchPlaceholder: 'Search',
            createGroup: 'Create Group',
            changeAvatar: 'Change Avatar',
            viewAllMembers: 'View All Members',
            sendMessage: 'Send Message',
            save: 'Save',
            quitGroup: 'Quit',
            dissolveGroup: 'Dissolve',
            shareCard: 'Share Card',
            complaint: 'Complaint',
            groupInfo: {
                owner: 'Group Owner',
                groupName: 'Group Name',
                remarkName: 'Remark Name',
                myNickname: 'My Nickname in Group',
                notice: 'Group Notice',
                noNotice: 'No notice set by group owner',
                groupMessageLanguage: 'Group Message Language',
                adminLanguage: 'Admin Language',
                selectLanguage: 'Select Language'
            },
            createDialog: {
                title: 'Create Group',
                inputPlaceholder: 'Please enter group name',
                inputError: 'Please enter group name',
                lengthError: 'Group name length cannot exceed 20 characters'
            },
            success: {
                create: 'Created successfully',
                send: 'Sent successfully',
                save: 'Modified successfully',
                removeMember: 'You removed {count} members',
                muteMember: 'You muted {count} members',
                unmuteMember: 'You unmuted {count} members',
                dissolve: 'Group "{name}" has been dissolved',
                quit: 'You have quit "{name}"'
            },
            confirm: {
                dissolve: 'Are you sure you want to dissolve "{name}"?',
                dissolveTitle: 'Confirm Dissolve?',
                quit: 'Are you sure you want to quit "{name}" and clear chat records?',
                quitTitle: 'Confirm Quit?'
            },
            menu: {
                chat: 'Send Message',
                shareCard: 'Share Card',
                complaint: 'Complaint',
                dissolve: 'Dissolve Group',
                quit: 'Quit Group'
            }
        },
        Setting: {
            menu: {
                personalInfo: 'Personal Information',
                userConfig: 'User Settings',
                bindPhone: 'Bind Phone',
                bindEmail: 'Bind Email',
                modifyPassword: 'Change Password',
                realnameAuth: 'Real-name Authentication'
            }
        },
        Home: {
            exit: 'Exit',
            alert: {
                forceOffline: {
                    message: 'You have logged in elsewhere and will be forced to log out',
                    title: 'Force Logout Notification'
                },
                banned: {
                    message: 'Your account has been banned by the administrator. Reason: {reason}',
                    title: 'Account Banned'
                },
                unreg: {
                    message: 'Your account has been deleted'
                },
                confirm: 'Confirm'
            },
            message: {
                initFail: 'Initialization failed',
                reconnecting: 'Connection lost, trying to reconnect...',
                reconnectSuccess: 'Reconnected successfully',
                offlineMessageFail: 'Failed to pull offline messages'
            },
            systemNotice: 'System Notification',
            unknownUser: 'Unknown User',
            unknownGroup: 'Unknown Group'
        },
        ChatBox: {
            groupInfo: 'Group Info',
            translatePlaceholder: 'Please enter content to translate...',
            translate: {
                emptyTip: 'Please enter content to translate'
            },
            forward: 'Forward Message',
            atTip: 'Someone @ mentioned me',
            newMessageTip: '{count} new messages',
            scrollToBottom: 'Scroll to bottom',
            sendBtn: 'Send',
            tool: {
                emotion: 'Emoji',
                translate: 'Translate',
                screenshot: 'Screenshot (CTRL + ALT + A)',
                image: 'Send Image',
                video: 'Send Video',
                file: 'Send File',
                receipt: 'Read Receipt',
                voice: 'Send Voice',
                voiceCall: 'Voice Call',
                groupCall: 'Group Call',
                videoCall: 'Video Call',
                history: 'Chat History'
            },
            screenshot: {
                hideWindow: 'Hide current window when taking screenshots'
            },
            call: {
                notFriend: 'You are no longer friends with this user, cannot call',
                inCall: 'You are already in a call'
            },
            copy: {
                success: 'Content copied to clipboard',
                fail: 'Copy failed, please copy manually'
            },
            resend: {
                notSupported: 'This message does not support automatic resending, please resend manually'
            },
            delete: {
                confirm: 'Confirm to delete this message?',
                title: 'Delete Message',
                confirmBtn: 'Confirm',
                cancelBtn: 'Cancel'
            },
            sticker: {
                addSuccess: 'Added to custom stickers'
            },
            batchDelete: {
                selectFirst: 'Please select messages to delete first',
                confirm: 'Confirm to delete {count} selected messages?',
                title: 'Batch Delete Messages',
                confirmBtn: 'Confirm',
                cancelBtn: 'Cancel',
                success: 'Deleted successfully'
            },
            batchForward: {
                selectFirst: 'Please select messages to forward first',
                filterTip: 'Some of your selected messages (contact cards, call messages, or failed messages) cannot be forwarded. Continue?',
                tipTitle: 'Tip',
                confirmBtn: 'Continue Sending',
                cancelBtn: 'Cancel',
                noMessages: 'No messages to forward',
                success: 'Successfully forwarded {count} messages to {chats} conversations',
                partialSuccess: 'Successfully forwarded {success}/{total} messages, some failed'
            },
            mergeForward: {
                minCount: 'At least 2 messages are required for merged forwarding',
                unsentTip: 'You have {count} unsent messages that cannot be forwarded. Continue with other messages?',
                tipTitle: 'Tip',
                confirmBtn: 'Continue Forwarding',
                cancelBtn: 'Cancel',
                noMessages: 'No messages to forward',
                title: 'Chat History',
                groupTitle: 'Chat history of group "{groupName}"',
                privateTitle: 'Chat history between "{name1}" and "{name2}"'
            },
            multiSelect: {
                selected: 'Selected {count}/20 messages',
                maxLimit: 'Maximum 20 messages',
                forwardOneByOne: 'Forward One by One',
                mergeForward: 'Merge Forward',
                delete: 'Delete',
                cancel: 'Cancel'
            }
        },
        ChatTopMessage: {
            title: 'Pinned Message',
            remove: 'Remove',
            confirmRemove: 'This pinned message will be removed for all members in the current group chat. Confirm removal?',
            removeTitle: 'Remove Pin',
            removeBtn: 'Remove',
            cancelBtn: 'Cancel'
        },
        ChatQuoteMessage: {
            userCard: 'User Card',
            groupCard: 'Group Card',
            mergeForward: 'Merge Forward',
            mergeForwardCount: 'Total {count} messages',
            unsupportedType: '[Message type not supported]'
        },
        ChatMessageItem: {
            groupOwner: 'Group Owner',
            groupManager: 'Group Manager',
            messageCount: '{count} messages',
            unsupportedType: '[Message type not supported]',
            readed: 'Read',
            unread: 'Unread',
            allRead: 'All read',
            readCount: '{count} people read',
            menu: {
                copy: 'Copy',
                addSticker: 'Add to Stickers',
                multiSelect: 'Multi-select',
                delete: 'Delete',
                recall: 'Recall',
                quote: 'Quote',
                forward: 'Forward',
                top: 'Pin',
                locateQuote: 'Locate Original Message'
            }
        },
        ChatGroupSide: {
            members: 'Group Members',
            viewAllMembers: 'View all {count} members',
            invite: 'Invite',
            inviteTip: 'Invite friends to group chat',
            remove: 'Remove',
            removeTip: 'Select members to remove from group chat',
            removeTitle: 'Select members to remove',
            mute: 'Mute',
            muteTip: 'Mute',
            muteTitle: 'Select members to mute',
            unmute: 'Unmute',
            unmuteTip: 'Unmute',
            unmuteTitle: 'Select members to unmute',
            notDisturb: 'Do Not Disturb',
            pinChat: 'Pin Chat',
            allMute: 'Mute All',
            allowInvite: 'Allow regular members to invite friends',
            allowShareCard: 'Allow regular members to share cards',
            autoTranslate: 'Auto Translate',
            groupName: 'Group Name',
            enterGroupName: 'Please enter group name',
            clickSetGroupName: 'Click to set group name',
            remarkName: 'Remark Name',
            clickSetRemark: 'Click to set remark',
            myNickname: 'My Nickname in Group',
            enterNickname: 'Please enter nickname',
            clickSetNickname: 'Click to set nickname',
            groupNotice: 'Group Notice',
            clickSetNotice: 'Click to set group notice',
            editNotice: 'Edit Group Notice',
            enterNotice: 'Please enter group notice',
            clearChat: 'Clear Chat History',
            quitGroup: 'Quit Group',
            complaintTip: 'Harassed? Report this group',
            dndEnabled: 'Do Not Disturb enabled',
            dndDisabled: 'Do Not Disturb disabled',
            chatPinned: 'Chat pinned',
            chatUnpinned: 'Chat unpinned',
            operationFailed: 'Operation failed, please try again',
            membersRemoved: 'You removed {count} members',
            membersMuted: 'You muted {count} members',
            membersUnmuted: 'You unmuted {count} members',
            quitConfirm: 'After quitting the group chat, you will no longer receive messages from the group. Confirm to quit?',
            confirmQuit: 'Confirm Quit?',
            clearConfirm: 'Are you sure you want to clear all chat records of "{name}"?',
            clearChatRecords: 'Clear Chat History',
            chatCleared: 'You cleared the chat history of "{name}"'
        },
        HeadImage: {
            online: 'Online'
        },
        ResizableAside: {
            resize: {
                title: 'Resize'
            }
        },
        CaptchaImage: {
            title: 'Verification Code',
            placeholder: 'Please enter verification code',
            required: 'Please enter verification code',
            error: 'Verification code error'
        },
        NoDataTip: {
            default: 'No data'
        },
        ChatItem: {
            tags: {
                group: 'Group',
                top: 'Pinned',
                official: 'Official'
            },
            atText: {
                someone: 'Someone @ me',
                all: 'Someone @ everyone'
            },
            menu: {
                top: 'Pin Chat',
                cancelTop: 'Unpin Chat',
                viewInfo: 'View Info',
                newMessageAlert: 'New Message Alert',
                doNotDisturb: 'Do Not Disturb',
                deleteChat: 'Delete Chat'
            }
        },
        RtcPrivateVideo: {
            waiting: 'Waiting for the other party to answer...',
            hangup: 'Hang up',
            error: {
                deviceNotSupport: 'The other party\'s device does not support calls',
                acceptedOnOtherDevice: 'Answered on another device',
                rejectedOnOtherDevice: 'Rejected on another device',
                rejected: 'The other party has rejected your call request',
                notAnswered: 'You did not answer',
                otherNotAnswered: 'The other party did not answer',
                otherCanceled: 'The other party canceled the call',
                otherHungUp: 'The other party has hung up'
            },
            success: {
                hangup: 'You have hung up, call ended',
                cancel: 'Call canceled, call ended'
            }
        },
        UserInfo: {
            tag: {
                deleted: 'Deleted',
                banned: 'Banned'
            },
            copyUserId: 'Copy User ID',
            signature: {
                label: 'Signature',
                default: 'This user has not set a signature'
            },
            button: {
                sendMessage: 'Send Message',
                addFriend: 'Add Friend'
            },
            status: {
                waitingApprove: 'Waiting for approval'
            },
            copy: {
                success: 'Copied successfully: {content}',
                fail: 'Copy failed'
            }
        },
        ChatPrivateSide: {
            dnd: 'Do Not Disturb',
            top: 'Pin',
            blacklist: 'Blacklist',
            remark: 'Remark',
            enterRemark: 'Please enter remark',
            clickSetRemark: 'Click to set remark',
            cleanChat: 'Clear Chat',
            deleteFriend: 'Delete Friend',
            complaint: 'Complaint',
            message: {
                dndEnabled: 'Do Not Disturb enabled',
                dndDisabled: 'Do Not Disturb disabled',
                chatPinned: 'Chat pinned',
                chatUnpinned: 'Chat unpinned',
                operationFailed: 'Operation failed, please try again',
                addToBlacklist: "Added '{name}' to blacklist",
                removeFromBlacklist: "Removed '{name}' from blacklist",
                chatCleared: "You cleared chat records with '{name}'",
                remarkSaved: 'Remark saved successfully',
                remarkCleared: 'Remark cleared',
                friendDeleted: "Friend '{name}' deleted",
                deleteFailed: 'Deletion failed, please try again',
                copySuccess: "Content '{content}' copied to clipboard",
                copyFailed: 'Copy failed, please copy manually'
            },
            confirm: {
                addToBlacklist: "You will no longer receive messages from this user. Confirm adding '{name}' to blacklist?",
                addToBlacklistTitle: 'Add to Blacklist',
                clearChat: "Are you sure you want to clear all chat records with '{name}'?",
                clearChatTitle: 'Clear Chat Records',
                deleteFriend: "Are you sure you want to delete friend '{name}'? It cannot be recovered after deletion.",
                deleteFriendTitle: 'Delete Friend',
                confirmButton: 'Confirm',
                cancelButton: 'Cancel'
            }
        }
    },
    setting: {
        language: 'Language Settings',
        switchLanguage: 'Switch Language',
        currentLanguage: 'Current Language'
    }
}
